import React from "react";
import Head from "../../components/Head";
import { Large } from "../../components/Type";
import W from "../../docs/custom-overlays/index.mdx";
import WJA from "../../docs/custom-overlays/index_ja.mdx";
import WEN from "../../docs/custom-overlays/index_en.mdx";
import { SingleFormAppShell } from "../../components/SingleFormAppShell";
import { MDXWrapper } from "../../mdx/settings";
import { loadCatalog } from "../../i18n";
import { useLingui } from "@lingui/react";
import { Trans, msg } from "@lingui/macro";

export async function getStaticProps({ params, ...ctx }) {
  const translation = await loadCatalog(ctx.locale);
  return { props: { translation } };
}

export default () => {
  const { i18n, _ } = useLingui();
  const DocCustomOverlay = (() => {
    switch (i18n.locale) {
      case "id":
        return W;
      case "ja":
        return WJA;
      case "en":
        return WEN;
      default:
        return W;
    }
  })();

  return (
    <SingleFormAppShell>
      <Head title={_(msg`Custom Overlays`)}>
        <link
          rel="stylesheet"
          href="https://unpkg.com/dracula-prism/dist/css/dracula-prism.css"
        ></link>
      </Head>

      <Large mt="1em" mb="1em">
        <Trans>Custom Overlays</Trans>
      </Large>

      <MDXWrapper>
        <DocCustomOverlay />
      </MDXWrapper>
    </SingleFormAppShell>
  );
};
